import logo from '../assets/logo_ekynair.png';
import React, { useState, useEffect } from 'react';
import { BRAND } from '../constants/theme';
import { mainLine, tooltipTitle } from '../shared/buildInfo';

const ResetPassword = ({ onSuccess, darkMode }) => {
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    // Extraire le token de l'URL
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('token');
    if (urlToken) {
      setToken(urlToken);
    } else {
      setMessage({ type: 'error', text: 'Token manquant dans l\'URL' });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    if (newPassword !== confirmPassword) {
      setMessage({ type: 'error', text: 'Les mots de passe ne correspondent pas' });
      setLoading(false);
      return;
    }

    try {
      const response = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });

      const data = await response.json();

      if (data.success) {
        setMessage({ type: 'success', text: 'Mot de passe réinitialisé avec succès !' });
        setTimeout(() => {
          if (onSuccess) onSuccess();
        }, 2000);
      } else {
        setMessage({ type: 'error', text: `${data.message}` });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Erreur de connexion au serveur' });
    } finally {
      setLoading(false);
    }
  };

  const containerStyle = {
    minHeight: '100vh',
    background: darkMode ? '#0f172a' : '#f8f9fa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  const formStyle = {
    background: darkMode ? '#1E1E32' : '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: darkMode ? '0 10px 40px rgba(0, 0, 0, 0.5)' : '0 10px 40px rgba(0, 0, 0, 0.1)',
    maxWidth: '450px',
    width: '100%'
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    borderRadius: '6px',
    border: darkMode ? '1px solid rgba(77, 198, 255, 0.3)' : '1px solid #ddd',
    background: darkMode ? '#34495E' : '#fff',
    color: darkMode ? '#E1E1E1' : '#2C3E50',
    fontSize: '14px',
    marginBottom: '15px'
  };

  const buttonStyle = {
    width: '100%',
    padding: '12px',
    background: loading ? '#999' : BRAND.gradient,
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: loading ? 'not-allowed' : 'pointer',
    marginTop: '10px'
  };

  return (
    <div style={containerStyle}>
      <div style={formStyle}>
        <div style={{ textAlign: 'center', marginBottom: '12px' }}>
          <img src={logo} alt="EkynAir" style={{ height: '80px' }} />
        </div>
        <h2 style={{
          color: darkMode ? '#E1E1E1' : '#2C3E50',
          marginBottom: '10px',
          fontSize: '20px',
          textAlign: 'center',
          fontFamily: "'Poppins', sans-serif"
        }}>
          Réinitialiser le mot de passe
        </h2>
        
        <p style={{
          color: darkMode ? '#E8EDF2' : '#4A5568',
          fontSize: '14px',
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          Choisissez un nouveau mot de passe sécurisé
        </p>

        {message && (
          <div style={{
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '20px',
            background: message.type === 'success' 
              ? (darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(76, 175, 80, 0.1)')
              : (darkMode ? 'rgba(244, 67, 54, 0.2)' : 'rgba(244, 67, 54, 0.1)'),
            color: message.type === 'success'
              ? (darkMode ? '#81C784' : '#388E3C')
              : (darkMode ? '#EF5350' : '#D32F2F'),
            fontSize: '14px',
            textAlign: 'center'
          }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px', position: 'relative' }}>
            <label style={{
              display: 'block',
              marginBottom: '5px',
              color: darkMode ? '#E8EDF2' : '#4A5568',
              fontSize: '14px'
            }}>
              Nouveau mot de passe *
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Minimum 8 caractères"
                required
                style={inputStyle}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '12px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '18px'
                }}
              >
                {showPassword ? 'Masquer' : 'Afficher'}
              </button>
            </div>
            <div style={{
              fontSize: '12px',
              color: darkMode ? '#E8EDF2' : '#4A5568',
              marginTop: '5px'
            }}>
              8+ caractères, majuscule, chiffre, spécial
            </div>
          </div>

          <div style={{ marginBottom: '15px', position: 'relative' }}>
            <label style={{
              display: 'block',
              marginBottom: '5px',
              color: darkMode ? '#E8EDF2' : '#4A5568',
              fontSize: '14px'
            }}>
              Confirmer le mot de passe *
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showConfirm ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Retapez le mot de passe"
                required
                style={inputStyle}
              />
              <button
                type="button"
                onClick={() => setShowConfirm(!showConfirm)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '12px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '18px'
                }}
              >
                {showConfirm ? 'Masquer' : 'Afficher'}
              </button>
            </div>
          </div>

          <button type="submit" style={buttonStyle} disabled={loading}>
            {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
          </button>
        </form>

        <div title={tooltipTitle} style={{
          textAlign: 'center',
          paddingTop: '20px',
          fontSize: '12px',
          color: darkMode ? '#E8EDF2' : '#4A5568'
        }}>
          {mainLine}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
